"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTypography", {
  enumerable: true,
  get: function get() {
    return _SVBTypography.default;
  }
});
var _SVBTypography = _interopRequireDefault(require("./src/SVBTypography"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }